import HeaderItem from "src/components/field/fields/Editor/HeaderItem";
import ImageHeadItem from "src/components/field/fields/Editor/items/ImageHeadItem";

interface HeaderProps {
	editor: any;
}

const Header = ({ editor }: HeaderProps) => {
	return (
		<div className="flex items-center rounded-md shadow p-1 gap-1">
			<HeaderItem
				active={editor.isActive("heading", {
					level: 2,
				})}
				icon="fas fa-h1"
				onChange={() => editor.commands.toggleHeading({ level: 2 })}
			/>
			<HeaderItem
				active={editor.isActive("heading", {
					level: 3,
				})}
				icon="fas fa-h2"
				onChange={() => editor.commands.toggleHeading({ level: 3 })}
			/>
			<HeaderItem
				icon="fas fa-text"
				onChange={() => {
					// editor.commands.setParagraph()
					let chain = editor.chain().focus().setParagraph();
					if (editor.isActive("bold")) {
						chain = chain.toggleBold();
					}

					if (editor.isActive("bulletList")) {
						chain = chain.toggleBulletList();
					}

					if (editor.isActive("orderedList")) {
						chain = chain.toggleOrderedList();
					}

					chain.run();
				}}
			/>
			<HeaderItem
				disabled={!editor.can().chain().focus().toggleBold().run()}
				active={editor.isActive("bold")}
				icon="fas fa-bold"
				onChange={() => editor.chain().focus().toggleBold().run()}
			/>
			<HeaderItem
				disabled={
					!editor.can().chain().focus().toggleBulletList().run()
				}
				active={editor.isActive("bulletList")}
				icon="fas fa-list"
				onChange={() => editor.chain().focus().toggleBulletList().run()}
			/>
			<HeaderItem
				disabled={
					!editor.can().chain().focus().toggleOrderedList().run()
				}
				active={editor.isActive("orderedList")}
				icon="fas fa-list-ol"
				onChange={() =>
					editor.chain().focus().toggleOrderedList().run()
				}
			/>
			<ImageHeadItem {...{ editor }} />

			<div className="flex-1"></div>
			<HeaderItem
				disabled={!editor.can().chain().focus().undo().run()}
				icon="fas fa-undo"
				onChange={() => editor.chain().focus().undo().run()}
			/>
			<HeaderItem
				disabled={!editor.can().chain().focus().redo().run()}
				icon="fas fa-redo"
				onChange={() => editor.chain().focus().redo().run()}
			/>
		</div>
	);
};

export default Header;
